// aquilo's TextArea look at the Consent Banner tab's 14px body size. Passing `className` to aquilo's TextArea replaces
// its classes, so this repeats them in full.
export const CONSENT_TEXTAREA_CLASSES =
  "block w-full rounded-md border-0 px-[12px] py-[8px] text-[14px] leading-[20px] text-neutral-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-600";

// Same box, greyed out, for text that can't be edited (e.g. the default banner text).
export const CONSENT_READONLY_TEXTAREA_CLASSES =
  "block w-full cursor-default resize-none rounded-md border-0 bg-neutral-100 px-[12px] py-[8px] text-[14px] leading-[20px] text-neutral-700 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none";

// Passed to aquilo's TextInput `inputTextSize`.
export const CONSENT_INPUT_TEXT_SIZE = "text-[14px]";
